import Instance from '../../../../utils/Axios';

const GetValidacaoIndividualAD = (id) => async (dispatch) => {
  await Instance()
    .get(`/obras/validacao/administradores/${id}`)
    .then(({ data }) => {
      console.log(data);
      dispatch({ type: 'GET_VALIDACAO_INDIVIDUAL_AD', payload: data.yData[0] });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetValidacaoIndividualAD;
